import { render } from "./OpportunityIso.vue?vue&type=template&id=5bbd6b8c&scoped=true"
import script from "./OpportunityIso.vue?vue&type=script&lang=js"
export * from "./OpportunityIso.vue?vue&type=script&lang=js"

import "./OpportunityIso.vue?vue&type=style&index=0&id=5bbd6b8c&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbd6b8c"]])

export default __exports__